import React from 'react';
import './IdleWarningModal.css';

interface IdleWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStartTask: () => void;
  idleMinutes: number;
}

const IdleWarningModal: React.FC<IdleWarningModalProps> = ({
  isOpen,
  onClose,
  onStartTask,
  idleMinutes
}) => {
  if (!isOpen) return null;

  return (
    <div className="idle-modal-overlay">
      <div className="idle-modal">
        <div className="idle-modal-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        
        <h2 className="idle-modal-title">You've Been Idle</h2>
        
        <p className="idle-modal-message">
          You've been clocked in for <strong>{idleMinutes} minutes</strong> without 
          starting a task. Please start tracking a task or clock out if you're taking a break.
        </p>
        
        <div className="idle-modal-actions">
          <button className="idle-btn start-task" onClick={onStartTask}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polygon points="5 3 19 12 5 21 5 3"></polygon>
            </svg>
            Start a Task
          </button>
          <button className="idle-btn dismiss" onClick={onClose}>
            Dismiss
          </button>
        </div>
        
        <p className="idle-modal-note">
          A notification has been sent to remind you.
        </p>
      </div>
    </div>
  );
};

export default IdleWarningModal;

